import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { IUserLoginStore } from './types';

const useUserStore = create<IUserLoginStore>()(
  persist(
    (set) => ({
      user: null,
      profile: null,
      isAuth: false,
      setUser: (user) => set({ user, isAuth: true }),
      setProfile: (profile) => set({ profile }),
      removeUser: () => set({ user: null, profile: null, isAuth: false }),
    }),
    {
      name: 'user',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export { useUserStore };
